"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDropzone = _interopRequireDefault(require("react-dropzone"));

var _check = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/check-2"));

var _delete = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/delete"));

var _upload = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/upload-2"));

var _underscore = _interopRequireDefault(require("underscore"));

var _filesize = _interopRequireDefault(require("filesize"));

require("./FileUpload.less");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var FileUpload = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(FileUpload, _React$Component);

  var _super = _createSuper(FileUpload);

  function FileUpload(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FileUpload);
    _this = _super.call(this, props);
    _this.state = {
      file: _this.props.file
    };
    return _this;
  }

  (0, _createClass2.default)(FileUpload, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref) {
      var file = _ref.file;

      if (file !== this.state.file) {
        this.setState({
          file: file
        });
      }
    }
  }, {
    key: "handleFileDrop",
    value: function handleFileDrop(file, rejectedFiles) {
      var _this$props = this.props,
          handleUploadFile = _this$props.handleUploadFile,
          handleMessage = _this$props.handleMessage,
          allowedFileTypes = _this$props.allowedFileTypes,
          maxSize = _this$props.maxSize;

      if (rejectedFiles.length > 0) {
        if (typeof maxSize === 'number' && rejectedFiles[0].size > maxSize) {
          handleMessage('FILE SIZE TOO LARGE: Your file exceeds the maximum file size of ' + (0, _filesize.default)(maxSize) + '. Please try a smaller file.', 'error');
        } else {
          handleMessage("Invalid file type! Only ".concat(allowedFileTypes.join(', '), " are accepted."), 'error');
        }

        return false;
      }

      this.setState({
        file: file
      }, function () {
        return handleUploadFile(file);
      });
    }
  }, {
    key: "clearDownload",
    value: function clearDownload(e) {
      var _this2 = this;

      e.stopPropagation();
      this.setState({
        file: undefined
      }, function () {
        return _this2.props.handleUploadFile(undefined);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var allowedFileTypes = this.props.allowedFileTypes;
      var acceptedFileTypes = allowedFileTypes.map(function (x) {
        return '.' + x;
      }).join();
      var dropZoneProps = {
        className: "form-drop-zone".concat(!_underscore.default.isUndefined(this.state.file) ? ' form-drop-zone-active' : ''),
        disableClick: !_underscore.default.isUndefined(this.state.file),
        multiple: false,
        onDrop: function onDrop(file, rejectedFiles) {
          return _this3.handleFileDrop(file.length > 0 ? file[0] : undefined, rejectedFiles);
        },
        accept: acceptedFileTypes
      };

      if (typeof this.props.maxSize !== 'undefined') {
        dropZoneProps.maxSize = this.props.maxSize;
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "form-upload"
      }, /*#__PURE__*/_react.default.createElement(_reactDropzone.default, dropZoneProps, !_underscore.default.isUndefined(this.state.file) ? /*#__PURE__*/_react.default.createElement("div", {
        className: "form-drop-zone-has-file-wrapper"
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_check.default, null)), /*#__PURE__*/_react.default.createElement("div", {
        className: "file-name"
      }, (this.state.file || {
        name: ''
      }).name), /*#__PURE__*/_react.default.createElement("div", {
        onClick: function onClick(e) {
          return _this3.clearDownload(e);
        }
      }, /*#__PURE__*/_react.default.createElement(_delete.default, null))) : '', _underscore.default.isUndefined(this.state.file) ? /*#__PURE__*/_react.default.createElement("div", {
        className: "form-drop-zone-empty-wrapper"
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_upload.default, null), " ", this.props.uploadFileString), /*#__PURE__*/_react.default.createElement("div", {
        className: "form-media-types"
      }, _underscore.default.map(allowedFileTypes, function (ext) {
        return /*#__PURE__*/_react.default.createElement("div", {
          key: "file-type-".concat(ext)
        }, ext);
      }))) : ''));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        file: _propTypes.default.shape({
          name: _propTypes.default.string,
          type: _propTypes.default.string
        }),
        handleUploadFile: _propTypes.default.func,
        handleMessage: _propTypes.default.func,
        uploadFileString: _propTypes.default.string,
        allowedFileTypes: _propTypes.default.arrayOf(_propTypes.default.string),
        maxSize: _propTypes.default.number
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        handleUploadFile: function handleUploadFile() {},
        handleMessage: function handleMessage(message, type) {
          console.log('message: ' + message + ' type: ' + type);
        },
        uploadFileString: 'Upload a file',
        allowedFileTypes: ['DOC', 'DOCX', 'PNG', 'JPG', 'JPEG', 'TXT', 'PDF']
      };
    }
  }]);
  return FileUpload;
}(_react.default.Component);

exports.default = FileUpload;